import { Button, Stack } from "@mui/material"
import { NavLink } from "react-router-dom"
import { usePostBotNavigationAccess } from "./postBotAccess"

/** Route/permission registration is separate. */
export function PostBotNavigation() {
  const { canRead, canAccessRetained } = usePostBotNavigationAccess()
  return (
    <Stack
      component="nav"
      aria-label="PostBot"
      direction="row"
      flexWrap="wrap"
      useFlexGap
      spacing={1}
    >
      {[
        ...(canRead
          ? [
              ["templates", "Шаблоны"],
              ["publications", "Публикации"],
              ["placements", "Размещения"],
              ["media", "Медиа"],
            ]
          : []),
        ...(canAccessRetained ? [["channels", "Каналы"]] : []),
      ].map(([path, label]) => (
        <Button
          key={path}
          component={NavLink}
          size="small"
          to={`/telegram/post-bot/${path}`}
          sx={{ "&.active": { bgcolor: "action.selected" } }}
        >
          {label}
        </Button>
      ))}
    </Stack>
  )
}
